import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../stores/app';
import { listProblemStatements } from '../api/problems';
import { deriveStatus } from '../lib/status';
import { StatusBadge } from '../components/StatusBadge';
import { ItemCard } from '../components/ItemCard';
import { EmptyState } from '../components/EmptyState';

export function ProblemList() {
  const sessionId = useAppStore((s) => s.activeSessionId);
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['problems', sessionId],
    queryFn: () => listProblemStatements(sessionId!),
    enabled: !!sessionId,
  });

  if (!sessionId) {
    return (
      <EmptyState
        icon="👆"
        title="Keine Session ausgewählt"
        description="Wähle oben eine Session aus."
      />
    );
  }

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin h-8 w-8 border-4 border-brand-600 border-t-transparent rounded-full" />
      </div>
    );
  }

  const problems = data ?? [];

  if (problems.length === 0) {
    return (
      <EmptyState
        icon="🔍"
        title="Keine Probleme in dieser Session"
        description="Starte den Wizard in der Hauptanwendung, um Probleme zu generieren."
      />
    );
  }

  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">Problem-Statements</h1>
        <span className="text-sm text-gray-500">{problems.length} Einträge</span>
      </div>

      <div className="grid gap-3">
        {problems.map((p) => {
          const status = deriveStatus(p);
          return (
            <ItemCard
              key={p.id}
              title={p.topic}
              subtitle={p.statement}
              badge={<StatusBadge status={status} />}
              meta={`CTR: ${p.ctr != null ? `${(p.ctr * 100).toFixed(2)}%` : '–'} · Priorität: ${p.priority ?? '–'}`}
              onClick={() => navigate(`/problems/${p.id}`)}
            />
          );
        })}
      </div>
    </div>
  );
}
